import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from 'src/app/shared/services/base-api.service';
import { environment } from 'src/environments/environment';
import { BankAccountCreateInputDto, BankAccountDetail, CheckoutPayRequestDto, CheckoutPaymentNotifyInputDto, ClaimRequestCreateDto, CreateInternationalBankAccountInputDto, Currency, DeleteBankAccountRequest, UploadFileDto } from '../../data-models/payment.data.models';
import { GeneralResponse } from '../../data-models/shared.data-models';

@Injectable({
  providedIn: 'root'
})
export class PaymentDataService {

  
  private controllerUrl:string=`${environment.appConfig.gatewayServiceBaseUrl}/api/Portal/PortalBankAccount/`;

  constructor(
    private baseApi:BaseApiService<any>,
  ) { }

  CheckoutPay(body:CheckoutPayRequestDto): Observable<any> {
    return this.baseApi.Post(`${this.controllerUrl}Checkout/Pay`,body);
  }
  CheckoutPaymentNotify(body:CheckoutPaymentNotifyInputDto): Observable<any> {
    return this.baseApi.Post(`${this.controllerUrl}Checkout/PaymentNotify`,body);
  }
  GetVerifiedBankAccountsByUser(): Observable<any> {
    return this.baseApi.Get(`${this.controllerUrl}BankAccounts/GetVerifiedBankAccountsByUser`);
  }
  GetBankAccountsByUser(): Observable<any> {
    return this.baseApi.Get(`${this.controllerUrl}GetBankAccount`);
  }
  UploadCertificateFile(body:UploadFileDto): Observable<any> {
    return this.baseApi.Post(`${this.controllerUrl}BankAccounts/UploadCertificateFile`,body);
  }
  CreateBankAccount(body:BankAccountCreateInputDto): Observable<any> {
    return this.baseApi.Post(`${this.controllerUrl}CreateBankAccount`,body);
  }
   CreateInternationalBankAccount(body:CreateInternationalBankAccountInputDto ): Observable<any> {
    return this.baseApi.Post(`${this.controllerUrl}CreateInternationalBankAccount`,body);
  }
  GetAllBanks(): Observable<any> {
    return this.baseApi.Get(`${this.controllerUrl}GetAllBanks`);
  }
  GetAllCurrency(): Observable<GeneralResponse<Currency[]>> {
    return this.baseApi.Get(`${this.controllerUrl}GetAllCurrency`);
  }
  GetBankAccountById(id: string): Observable<GeneralResponse<BankAccountDetail>> {
    return this.baseApi.Get(`${this.controllerUrl}GetBankAccountById?id=${encodeURIComponent(id)}`);
  }

  DeleteBankAccount(body: DeleteBankAccountRequest): Observable<GeneralResponse<boolean>> {
    return this.baseApi.Post(`${this.controllerUrl}DeleteBankAccount`, body);
  }
  SetAsPrimary(id: string): Observable<GeneralResponse<boolean>> {
    return this.baseApi.Post(`${this.controllerUrl}SetAsPrimary?id=${encodeURIComponent(id)}`, {});
  }
  Request(body:ClaimRequestCreateDto): Observable<any> {
    return this.baseApi.Post(`${this.controllerUrl}BalanceClaim/Request`,body);
  }
  GetInvestorVIbanInfo(): Observable<any> {
    return this.baseApi.Get(`${this.controllerUrl}Investor/GetInvestorVIbanInfo`);
  }
}
